import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sqFt'
})
export class SqFtPipe implements PipeTransform {
  transform(item: any): any {
    const d = item.dimensions;
    let ret = 0;
    if(d.length && d.width) {
      ret = (parseFloat(d.length) * parseFloat(d.width))/144;
    } else {
      return ret;
    }

    if(d.length && d.width && d.lShape.length && d.lShape.width) {
      //let sf2 = (parseFloat(d.lShape.length) *  parseFloat(d.lShape.height))/144;
      //ret = ret-sf2;
      ret = ((parseFloat(d.width) * parseFloat(d.length)) + parseFloat(d.lShape.length) * (parseFloat(d.lShape.width) - parseFloat(d.width)))/144;
    }

    return ret.toFixed(2);

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/sq-ft-pipe.ts